import { render, staticRenderFns } from "./ProductCarouselAuto.vue?vue&type=template&id=4319184a&"
import script from "./ProductCarouselAuto.vue?vue&type=script&lang=ts&"
export * from "./ProductCarouselAuto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports